import React from 'react';

import {FlatButton} from '@pb/kit-component-button';
import {DropdownMenu, DropdownMenuItem} from '@pb/kit-component-dropdown-menu';
import Icon, {Icons} from '@pb/kit-component-icon';

type Props = {
    accountIds: number[],

    showAddToAccountTeam: boolean,
    openAddToAccountTeamTool: () => void,

    showRemoveFromAccountTeam: boolean,
    openRemoveFromAccountTeamTool: () => void,

    showSetAccountStatus: boolean,
    openSetAccountStatusTool: () => void,

    showUpdateLicense: boolean,
    openEnableModuleAccessPermissionsTool: () => void,
    openDisableModuleAccessPermissionsTool: () => void,
};

export const ToolsMenu = (props: Props) => (
    <DropdownMenu
        anchor={({positionRef, getAnchorProps, anchorRef}) => (
            <FlatButton
                endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                {...getAnchorProps()}
                ref={anchorRef}>
                <b>Bulk Actions</b>
            </FlatButton>
        )}>
        {(props.showAddToAccountTeam || props.showRemoveFromAccountTeam) ? (
            <DropdownMenuItem caption="Update Account Team" iconAfter={Icons.ANGLE_RIGHT}>
                {props.showAddToAccountTeam ? (
                    <DropdownMenuItem
                        caption="Add To Account Team"
                        onClick={props.openAddToAccountTeamTool}
                    />
                ) : null}
                {props.showRemoveFromAccountTeam ? (
                    <DropdownMenuItem
                        caption="Remove From Account Team"
                        onClick={props.openRemoveFromAccountTeamTool}
                    />
                ) : null}
            </DropdownMenuItem>
        ) : null}
        {props.showSetAccountStatus ? (
            <DropdownMenuItem
                caption="Set Account Status"
                onClick={props.openSetAccountStatusTool}
            />
        ) : null}
        {props.showUpdateLicense ? (
            <DropdownMenuItem caption="Update License" iconAfter={Icons.ANGLE_RIGHT}>
                <DropdownMenuItem
                    caption="Enable Module Access Permissions"
                    onClick={props.openEnableModuleAccessPermissionsTool}
                />
                <DropdownMenuItem
                    caption="Disable Module Access Permissions"
                    onClick={props.openDisableModuleAccessPermissionsTool}
                />
            </DropdownMenuItem>
        ) : null}
    </DropdownMenu>
);
